import { OpenTofuMigrationState, SearchInput, SearchQueryOrderDirection } from "types/generated";
import { makeStringEqualsPredicate } from "utils/predicates";

export const DASHBOARD_WIDGETS_OPEN_TOFU_MIGRATION_LIST_LIMIT = 5;

export const DASHBOARD_WIDGETS_OPEN_TOFU_READY_TO_MIGRATE_VARIABLES: { input: SearchInput } = {
  input: {
    first: DASHBOARD_WIDGETS_OPEN_TOFU_MIGRATION_LIST_LIMIT,
    after: null,
    fullTextSearch: null,
    orderBy: null,
    predicates: null,
    requestedPage: null,
  },
};

export const DASHBOARD_WIDGETS_OPEN_TOFU_MIGRATION_QUEUE_VARIABLES: { input: SearchInput } = {
  input: {
    first: DASHBOARD_WIDGETS_OPEN_TOFU_MIGRATION_LIST_LIMIT,
    after: null,
    fullTextSearch: null,
    requestedPage: null,
    predicates: [makeStringEqualsPredicate("state", [OpenTofuMigrationState.ToMigrate])],
    orderBy: [{ field: "updatedAt", direction: SearchQueryOrderDirection.Desc }],
  },
};

// Only the list mounted while the action can fire; refetching the unmounted Ready query makes Apollo warn.
export const DASHBOARD_WIDGETS_OPEN_TOFU_MIGRATION_CLEAR_QUEUE_REFETCH_QUERIES = [
  "GetOpenTofuMigrationCounts",
  "SearchOpenTofuMigrationQueue",
];
